module.exports = __webpack_public_path__ + "img/ic_process_start.1813efee.png";